import styled from 'styled-components';

export const MobileDropdownMenuContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;
